import { render } from "./GiftItem.vue?vue&type=template&id=f3119de2"
import script from "./GiftItem.vue?vue&type=script&lang=js"
export * from "./GiftItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__